import type { ModuleType } from '@ricoh/ria.client.core/types/core/app.type';

import type { ClientErrorOptions } from './_client.type';

import { BaseError } from './_base';

/** Client Error. */
export class ClientError extends BaseError {
  /** Module type. */
  module: ModuleType;

  /**
   * Create ClientError instance.
   *
   * @param {ClientErrorOptions} options Options.
   */
  constructor({ module, ...options }: ClientErrorOptions) {
    super(options);

    this.module = module;
  }

  /**
   * Create Error instance if cause is not Error.
   *
   * @param {ClientErrorOptions} options Options.
   *
   * @returns {BaseError} Error instance.
   */
  static override create(options: ClientErrorOptions): BaseError {
    if (options.cause instanceof BaseError) {
      return options.cause;
    }

    return new ClientError(options);
  }
}
